import * as React from "react";
import {Sticky, StickyProps} from "react-sticky";
import HeaderMegamenuWide from "./header-megamenu-wide";
import HeaderMegamenuDropdown from "./header-megamenu-dropdown";
import Link from 'gatsby-link';
import { GoogleAnalyticsEventType } from "../../models/google-analytics";
import * as googleAnalyticsService from "../../services/google-analytics-service";
import * as staticUrls from "../../constants/static-urls";
import * as headerMenuData from "../../constants/header-menu-data";
import * as staticImages from "../../constants/static-images";
import styled from "styled-components";

interface StickyMenuProps extends ReactStickyPropsV6 {
  /** BIEŻĄCA LOKALIZACJA */
  pathName: string

  /** INFORMACJA CZY MENU JEST STICKY W PARENCIE */
  headerMenuIsSticky: boolean

  /** FUNKCJA ZMIENIAJĄCA STAN W PARENCIE */
  updateHeaderMenuState: (isSticky: boolean, stickyProps: ReactStickyPropsV6) => any
}

interface StickyMenuState {}

class StickyMenu extends React.Component<StickyMenuProps,StickyMenuState> {

  constructor(props: StickyMenuProps) {
    super(props);
    this.onAppRegisterButtonClick = this.onAppRegisterButtonClick.bind(this);
    this.onAppLoginButtonClick = this.onAppLoginButtonClick.bind(this);
  }

  componentDidUpdate() {
    const {headerMenuIsSticky,isSticky,wasSticky,updateHeaderMenuState} = this.props;

    // WYWOŁYWANIE FUNKCJI TYLKO JEŚLI SIĘ COŚ ZMIENIŁO
    if (isSticky != wasSticky && headerMenuIsSticky != isSticky) {
      updateHeaderMenuState(isSticky,this.props);
    }
  }

  onAppRegisterButtonClick() {
    googleAnalyticsService.trackEvent(GoogleAnalyticsEventType.NavigatedToAppRegisterPage);
  }

  onAppLoginButtonClick() {
    googleAnalyticsService.trackEvent(GoogleAnalyticsEventType.NavigatedToAppLoginPage);
  }

  render() {
    const {pathName,isSticky,style} = this.props;
    return (
      <div className="materialize-theme-styles">
        <header className={isSticky ? `tt-nav nav-border-bottom sticky` : `tt-nav nav-border-bottom`} style={isSticky ? {...style, width: "100%"} : DefaultHeaderPositioningStyle}>
          <div className="header-sticky light-header" style={{width: "100%"}}>
            <MenuContainerWrapper className="container">
              <MenuContainer className="menuzord">

                <LogoContainer data-header-is-sticky={isSticky}>
                  <LinkContainer to={staticUrls.FAKTUROMANIA_LANDING_PAGE_URL} className="logo-brand">
                    <LogoImageWrapper className="retina" data-header-is-sticky={isSticky}/>
                  </LinkContainer>
                </LogoContainer>

                <MenuContainerContentWrapper>
                  <NavigationMenuContainer>
                    <ul className="menuzord-menu pull-right scrollable menu-lg">
                      <HeaderMegamenuDropdown
                        dropdownName="Aplikacja"
                        dropdownElements={headerMenuData.APLIKACJA_MENU_WIDE_ITEM_ELEMENTS}
                      />
                      <HeaderMegamenuDropdown
                          dropdownName="Twoja spółka"
                          dropdownLink={staticUrls.FAKTUROMANIA_ZAKLADANIE_SPOLEK_ZOO_PAGE_URL}
                          dropdownElements={headerMenuData.TWOJA_SPOLKA_MENU_WIDE_ITEM_ELEMENTS}
                      />
                      <HeaderMegamenuDropdown
                        dropdownName="Biuro rachunkowe"
                        dropdownLink={staticUrls.FAKTUROMANIA_BIURO_RACHUNKOWE_PAGE_URL}
                        dropdownElements={headerMenuData.USLUGI_MENU_DROPDOWN_ITEM_ELEMENTS}
                      />
                      <HeaderMegamenuDropdown
                          dropdownName="Kalkulatory"
                          dropdownElements={headerMenuData.KALKULATORY_MENU_WIDE_ITEM_ELEMENTS}
                      />
                      <HeaderMegamenuDropdown
                        dropdownName="Pomoc"
                        dropdownElements={headerMenuData.POMOC_MENU_DROPDOWN_ITEM_ELEMENTS}
                      />
                      <HeaderMegamenuDropdown
                        dropdownName="Kontakt"
                        dropdownLink={staticUrls.FAKTUROMANIA_KONTAKT_PAGE_URL}
                        dropdownElements={headerMenuData.KONTAKT_MENU_DROPDOWN_ITEM_ELEMENTS}
                      />
                    </ul>

                    <ul className="menuzord-menu pull-right scrollable menu-sm">
                      <HeaderMegamenuDropdown
                        dropdownName="Info"
                        dropdownElements={headerMenuData.SMALL_DEVICE_MENU_DROPDOWN_ITEM_ELEMENTS}
                      />
                      <HeaderMegamenuDropdown
                        dropdownName="Usługi"
                        dropdownElements={headerMenuData.USLUGI_SMALL_DEVICES_MENU_DROPDOWN_ITEM_ELEMENTS}
                      />
                      <HeaderMegamenuDropdown
                          dropdownName="Pomoc"
                          dropdownElements={headerMenuData.POMOC_MENU_DROPDOWN_ITEM_ELEMENTS}
                      />
                      <HeaderMegamenuDropdown
                        dropdownName="Kontakt"
                        dropdownLink={staticUrls.FAKTUROMANIA_KONTAKT_PAGE_URL}
                        dropdownElements={headerMenuData.KONTAKT_MENU_DROPDOWN_ITEM_ELEMENTS}
                      />
                    </ul>
                  </NavigationMenuContainer>

                  <ApplicationMenuContainer data-header-is-sticky={isSticky}>
                    <a
                      className="waves-effect waves-light btn register-button"
                      href={staticUrls.FAKTUROMANIA_REGISTRATION_PAGE_URL}
                      target="_blank"
                      onClick={this.onAppRegisterButtonClick}
                    >
                      Rejestracja
                    </a>
                    <a
                      className="waves-effect waves-light btn login-button"
                      href={staticUrls.FAKTUROMANIA_LOGIN_PAGE_URL}
                      target="_blank"
                      onClick={this.onAppLoginButtonClick}
                    >
                      Logowanie
                    </a>
                  </ApplicationMenuContainer>
                </MenuContainerContentWrapper>

              </MenuContainer>
            </MenuContainerWrapper>
          </div>
        </header>
      </div>
    )
  }

}

/** HeaderMenu */

interface HeaderMenuProps {
  pathName: string
  headerMenuIsSticky: boolean
  updateHeaderMenuState: (isSticky: boolean, stickyProps: ReactStickyPropsV6) => any
}

interface HeaderMenuState {}

class HeaderMenu extends React.Component<HeaderMenuProps,HeaderMenuState> {

  render() {
    const {pathName,headerMenuIsSticky,updateHeaderMenuState} = this.props;
    return (
      <Sticky topOffset={46}>
        {(stickyProps: ReactStickyPropsV6) => {
          return (
            <StickyMenu
              {...stickyProps}
              pathName={pathName}
              headerMenuIsSticky={headerMenuIsSticky}
              updateHeaderMenuState={updateHeaderMenuState}
            />
          )
        }}
      </Sticky>
    )
  }

}

/** STYLES */

const DefaultHeaderPositioningStyle: React.CSSProperties = {
  position: "fixed",
  width: "100%"
};

const MenuContainerWrapper = styled.div`
  padding: 0 20px !important;
  width: 100% !important;
  max-width: none !important;
  display: flex;
`;

const MenuContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 63px;
`;

const MenuContainerContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  ul.menu-sm {
    display: none;
  }
  @media (max-width: 799px) {
    a {
      font-size: 13px !important;
    }
    ul.menu-lg {
      display: none;
    }
    ul.menu-sm {
      display: initial;
    }
  }
`;

/** LogoContainer => LOGO */
const LogoContainer = styled.div`
  &[data-header-is-sticky~="true"] {
    flex: 0 0 220px;
    @media (max-width: 1320px) {
      flex: 0 0 40px;
    }
  }
  align-self: center;
  border-right: 1px solid #dddddd;
  display: flex;
  align-items: center;
  height: 100%;
`;

const LinkContainer = styled(Link)`
  margin: 0 !important;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 1320px) {
    margin-right: 16px !important;
  }
`;

const LogoImageWrapper: any = styled.div`
  @media (min-width: 1320px) {
    background-image: url(${staticImages.FAKTUROMANIA_LOGO_AND_NAME});
    background-size: contain;
    background-repeat: no-repeat;
    width: 300px;
    height: 80px;
    &[data-header-is-sticky~="true"] {
      width: 220px;
      height: 55px;
    }
  }
  @media (max-width: 1320px) {
    background-image: url(${staticImages.FAKTUROMANIA_LOGO_ICON});
    background-size: contain;
    background-repeat: no-repeat;
    width: 40px;
    height: 40px;
  }
`;

/** NavigationMenuContainer => MENU Z LINKAMI DO PODSTRON */
const NavigationMenuContainer = styled.div`
  padding-left: 15px;
  margin-right: auto;
  @media (max-width: 599px) {
    a {
      height: 22px !important;
      line-height: 22px !important;
    }
  }
`;

/** ApplicationMenuContainer => MENU Z LINKAMI DO APLIKAJCI */
const ApplicationMenuContainer = styled.div`
  display: flex;
  align-self: center;
  padding-left: 20px;
  a.register-button {
    margin-right: 20px;
  }
  a {
    margin-bottom: 0px;
  }
  &[data-header-is-sticky~="true"] {
    a {
      height: 35px;
      padding: 4px 13px;
      font-size: 16px;
      line-height: 25px;
      border-radius: 2px;
    }
  }
  @media (max-width: 599px) {
    flex-direction: column;
    justify-content: space-between;
    a {
      width: 100%;
      height: 22px !important;
      line-height: 22px !important;
      padding: 0px 6px !important;
    }
    a:nth-of-type(1) {
      margin-bottom: 4px;
    }
  }
`;

export default HeaderMenu


// WEBPACK FOOTER //
// ./src/layouts/header/header.tsx